import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import { GetListRequest, GetPlannerListResponse } from '../../type/types';

// 센터 목록 조회
export const getPlannerList = async (params: GetListRequest) => {
  const query = Object.fromEntries(
    Object.entries(params).filter(
      ([_, v]) => v !== undefined && v !== null && v !== ''
    )
  );
  const res = await api.get<ApiResponseType<GetPlannerListResponse>>(
    `/api/web/admins/partners/planners`,
    { params: query }
  );
  return res.data;
};
